import AddLinkedin from "../LinkedinForm/AddLinkedinProfile";
import AddStepsSection from "../Customers/customerLinkedinData";
import { fetchMethod } from "../../FetchMethod";
import * as Yup from "yup";

export const addCustomerForm = {
  title: "Add New",
  fields: [
    {
      label: "Company",
      placeholder: "e.g. Smith",
      isRequired: true,
      type: "input",
      name: "company",
      value: ""
    },
    {
      label: "First Name",
      type: "input",
      placeholder: "e.g John",
      isRequired: true,
      name: "firstName",
      value: ""
    },
    {
      label: "Last Name",
      type: "input",
      placeholder: "e.g Anderson",
      name: "lastName",
      value: ""
    },
    {
      label: "Phone Number",
      placeholder: "e.g 9718785414",
      isRequired: true,
      type: "input",
      name: "contactno",
      value: ""
    },
    {
      label: "Email Address",
      placeholder: "e.g. smith.doe@gmail.com",
      isRequired: true,
      type: "input",
      name: "email",
      value: ""
    },
    {
      label: "Address",
      type: "textarea",
      placeholder: "Type Your Address here...",
      name: "address",
      value: ""
    },
    {
      label: "Profile",
      type: "table",
      compo: AddLinkedin,
      addoredit: AddStepsSection
    },
    {
      label: "Status",
      type: "radio",
      name: "active",
      value: "1",
      options: [
        { name: "Active", value: "1" },
        { name: "Inactive", value: "0" }
      ]
    }
  ]
};

export const addLinkedinForm = {
  title: "Add Linkedin Profile",
  fields: [
    {
      label: "Profile Name",
      type: "input",
      name: "name",
      isRequired: true,
      placeholder: "Enter Profile Name",
      value: ""
    },
    {
      label: "Linkedin Login ID",
      type: "input",
      name: "linkedinemail",
      isRequired: true,
      placeholder: "Enter Email Address",
      value: ""
    },
    {
      label: "Linkedin Password",
      type: "password",
      name: "linkedinpassword",
      isRequired: true,
      placeholder: "****************",
      value: ""
    },

  ]
};

const customer = id => `query{allCustomers(where:{id: ${id}}){
Customers{
id
firstName
lastName
contactno
company
address
email
active
}}}`;

const customerLinkedin = customerid => `query { allCustomerlinkedinprofiles(where: { customerid: ${customerid},active:1 }){
Customerlinkedinprofiles{
id
customerid
linkedinemail
linkedinpassword
hubspotid
hubspotpassword
hubspottoken
salesforceid
salesforcepassword
salesforcetoken
signature
name
active
}
}
}`;
export const getData = async id =>
  await fetchMethod(customer(id))
    .then(response => response.json())
    .then(data => data)
    .catch(e => console.log("Errror", e));

export const getLinkedinData = async customerid =>
  await fetchMethod(customerLinkedin(customerid))
    .then(response => response.json())
    .then(data => data)
    .catch(e => console.log("Error", e));

export const customersValidation = Yup.object().shape({
  firstName: Yup.string()
    .required("Please enter name")
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(30, "First name should be less than 30 characters"),
  lastName: Yup.string()
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", data => {
      if (data !== undefined && data.trim().length === 0 && data !== "")
        return false;
      else return true;
    })
    .max(30, "Last name should be less than 30 characters"),
  contactno: Yup.string()
    .required("Please enter phone no.")
    .matches(/^\+?[0-9]*$/, {
      message: "Please enter valid phone no.",
      excludeEmptyString: true
    })
    .max(16, "Phone number should be less than 16 digits"),

  email: Yup.string()
    .required("Please enter email-id")
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      {
        message: "Please enter valid email-id",
        excludeEmptyString: true
      }
    )
    .max(50, "Email should be less than 50 characters"),
  company: Yup.string()
    .required("Please enter company name")
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(100, "Company should be less than 100 characters"),
  address: Yup.string()
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(250, "Address should be less than 250 characters")
});

export const customerLinkedinValidation = Yup.object().shape({
  name: Yup.string()
    .required("Please enter profile name")
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(50, "Profile name should be less than 50 characters"),
  linkedinemail: Yup.string()
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      {
        message: "Please enter valid Linkedin login id",
        excludeEmptyString: true
      }
    )
    .required("Please enter Linkedin login id")
    .max(50, "Linkedin login id should be less than 50 characters"),
  linkedinpassword: Yup.string()
    .required("Please enter password")
    .max(70, "Linkedin password should be less than 70 characters"),
  signature: Yup.string()
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(100, "Signature should be less than 100 characters")
});

export const editCustomersValidation = Yup.object().shape({
  firstName: Yup.string()
    .required("Please enter name")
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(30, "First name should be less than 30 characters"),
  lastName: Yup.string()
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", data => {
      if (data !== undefined && data.trim().length === 0 && data !== "")
        return false;
      else return true;
    })
    .max(30, "Last name should be less than 30 characters"),
  contactno: Yup.string()
    .required("Please enter phone no.")
    .matches(/^\+?[0-9]*$/, {
      message: "Please enter valid phone no.",
      excludeEmptyString: true
    })
    .max(16, "Phone number should be less than 16 digits"),

  email: Yup.string()
    .required("Please enter email-id")
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      {
        message: "Please enter valid email-id",
        excludeEmptyString: true
      }
    )
    .max(50, "Email should be less than 50 characters"),

  company: Yup.string()
    .required("Please enter company name")
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(100, "Company should be less than 100 characters"),
  address: Yup.string()
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(250, "Address should be less than 250 characters")
});

export const editCustomerLinkedinValidation = Yup.object().shape({
  name: Yup.string()
    .required("Please enter profile name")
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(50, "Profile name should be less than 50 characters"),
  linkedinemail: Yup.string()
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      {
        message: "Please enter valid Linkedin login id",
        excludeEmptyString: true
      }
    )
    .required("Please enter Linkedin login id")
    .max(50, "Linkedin login id should be less than 50 characters"),
  linkedinpassword: Yup.string()
    .required("Please enter password")
    .max(70, "Linkedin password should be less than 70 characters"),

  signature: Yup.string()
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(100, "Signature should be less than 100 characters")
});
